const base = import.meta.env.VITE_SALONER10_URL || ''

export default [
  {
    title: 'timetable',
    to: { name: 'calendar' },
    icon: { icon: 'ri-calendar-event-fill' },
    name: 'calendar',
  },
  {
    title: 'messages',
    // href: new URL('panel/messages/', base).toString(),
    to: { name: 'messages' },
    icon: { icon: 'ri-mail-fill' },
    name: 'messages',
  },
  {
    title: 'customers',
    // href: new URL('panel/clients/', base).toString(),
    to: { name: 'clients' },
    icon: { icon: 'ri-group-fill' },
    name: 'clients',
  },
  {
    title: 'Statistics',
    // href: new URL('panel/statistics/', base).toString(),
    to: { name: 'statistics' },
    icon: { icon: 'ri-bar-chart-2-fill' },
    name: 'statistics',
  },
  {
    title: 'Storage',
    //href: new URL('panel/store/', base).toString(),
    to: { name: 'storage' },
    icon: { icon: 'ri-shopping-basket-fill' },
    name: 'store',
  },
  {
    title: 'manager',
    href: new URL('panel/settlements/', base).toString(),
    icon: { icon: 'ri-article-fill' },
    name: 'manager',
  },
  {
    title: 'radio',
    href: new URL('panel/radio/', base).toString(),
    icon: { icon: 'ri-music-2-fill' },
    name: 'radio',
  },
  {
    title: 'marketing',
    href: new URL('panel/marketing/', base).toString(),
    icon: { icon: 'ri-megaphone-fill' },
    name: 'marketing',
  },
  {
    title: 'settings',
    href: new URL('panel/settings/', base).toString(),
    icon: { icon: 'ri-settings-4-fill' },
    name: 'settings',
  },
  {
    title: 'ambassadorProgramme',
    //href: new URL('panel/ambassador/', base).toString(),
    to: { name: 'ambassador' },
    icon: { icon: 'ri-group-2-fill' },
    name: 'ambassador',
  },
  {
    title: 'support',
    // href: new URL('panel/help/', base).toString(),
    to: { name: 'help' },
    icon: { icon: 'ri-lifebuoy-fill' },
    name: 'help',
  },
]
